import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';

// Dezente Einblend-Animation pro Sektion (1x, IntersectionObserver)
export const Reveal = ({ as: Tag = 'div', className, children, ...props }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) { setInView(true); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { setInView(true); io.unobserve(entry.target); }
      });
    }, { threshold: 0.08 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag ref={ref} className={cn('reveal', inView && 'is-in', className)} {...props}>
      {children}
    </Tag>
  );
};

export default Reveal;
